import type { CalendarGridColDef } from '../../CalendarGrid.model';

export type Value = string | null | undefined;

const cikColDef: CalendarGridColDef<Value> = {
  field: 'issuer.cik',
  headerName: 'CIK',
  width: 90,
  type: 'text',
  filter: 'agTextColumnFilter',
};

export default cikColDef;
